import { forwardRef } from 'react';
import { Stack, StackProps } from '@mui/material';

/**
 * Standard stack suitable to contain two or more FormGridContainer with a default vertical gap between them.
 */
export const FormGridContainersStack = forwardRef<HTMLDivElement, StackProps>((props: StackProps, ref) => {
  return <Stack ref={ref} rowGap={2} {...props} />;
});
